//----for text in new line ------
export const newlineText = (text) => {
    const newText = text.split('\n').map(str => <p>{str}</p>);
    return newText;
};